const strings = value => (Array.isArray(value) ? value : [value]).filter(v => typeof v === 'string' && v.trim()).map(v => v.trim());
const clean = value => strings(value).find(v => !/^(unknown|n\/?a|none|default string|to be filled by o\.?e\.?m\.?|system serial number|0+)$/i.test(v)) || '';
const privateAddress = value => {
  if (typeof value !== 'string') return false;
  if (/^f[cd][0-9a-f]{2}:/i.test(value)) return true;
  const parts = value.split('.');
  if (parts.length !== 4 || parts.some(v => !/^\d{1,3}$/.test(v) || Number(v) > 255)) return false;
  const [a,b] = parts.map(Number);
  return a === 10 || (a === 172 && b >= 16 && b <= 31) || (a === 192 && b === 168);
};

export function getAssetIdentity(asset = {}, device = {}, interfaces = []) {
  const system = device.system || device.systemInfo || {};
  const nics = (Array.isArray(interfaces) ? interfaces : []).filter(n => n && typeof n === 'object');
  const addresses = nic => strings(nic.ipAddress || nic.ipAddresses || nic.ip_addresses);
  const usable = nics.filter(n => !/^(down|disconnected|disabled)$/i.test(n.status || '') && addresses(n).some(privateAddress));
  usable.sort((a,b) => Number(!!b.defaultGateway) - Number(!!a.defaultGateway) || Number(/^up$/i.test(b.status || '')) - Number(/^up$/i.test(a.status || '')));
  const primary = usable[0];
  const privateIps = primary ? addresses(primary).filter(privateAddress) : strings(device.ipAddresses || asset.ip_address).filter(privateAddress);
  const macs = strings(primary ? (primary.macAddress || primary.mac_address) : (device.macAddresses || asset.mac_address));
  const manufacturer = clean(system.manufacturer) || clean(asset.manufacturer);
  const model = clean(system.model) || clean(asset.model);
  return {
    publicIp: clean(device.publicIP || device.publicIp || asset.public_ip),
    privateIp: [...new Set(privateIps)].join(', '),
    mac: [...new Set(macs)].join(', '),
    serial: clean(system.serialNumber) || clean(system.biosSerialNumber) || clean(asset.serial_number) || clean(asset.service_tag),
    assetTag: clean(asset.asset_tag),
    interfaceName: primary?.interfaceName || primary?.name || '',
    model: model.toLowerCase().startsWith(manufacturer.toLowerCase()) ? model : [manufacturer, model].filter(Boolean).join(' ')
  };
}
